import { ActionBarContext, ModalService } from "@bb-vendure/admin-ui/core";
import { RequestPurchaseProductDocument } from "./generated-graphql/graphql";
import { take } from "rxjs";

export function checkProductStock(context: ActionBarContext) {
  const productId = context.route.snapshot.params.id;

  context.dataService
    .query(RequestPurchaseProductDocument, {
      productId: productId,
    })
    .single$.pipe(take(1))
    .subscribe((res) => {
      if (res.checkProductRequestPurchase) {
        context.notificationService.success(
          `Create/update ${res.checkProductRequestPurchase.length} purchase requests`
        );
      }
    });
}
